import { Card, Header, Progress } from '@mairistem/composants';
import React from 'react';
import './CreditPanel.css';

interface CreditPanelProps {
	progress: number;
}

const annee = new Date().getFullYear();

const CreditPanel = ({ progress }: CreditPanelProps) => (
	<Card fluid>
		<Card.Content>
			<Card.Meta>{`Crédits Consommés ${annee}`}</Card.Meta>
			<br />
			<Card.Header>
				<Header content={`${progress}%`} />
				<Progress
					className="creditPanelProgress"
					percent={progress}
					size="tiny"
				/>
			</Card.Header>
		</Card.Content>
	</Card>
);

export default CreditPanel;
